import { addInterviewInfo,
  getPositionList,
  getShowAllocation
} from '@/api/manpowerRecruitment'
import { getToken, setToken } from '@/utils/auth'
import { Notify } from 'vant'

const state = {
  token: getToken()
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    setToken(token)
  }
}

const actions = {
  setToken({ state, commit }, token) {
    commit('SET_TOKEN', token)
  },
  getShowAllocation(temp, data) {
    return new Promise((resolve, reject) => {
      getShowAllocation(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addInterviewInfo(temp, data) {
    return new Promise((resolve, reject) => {
      addInterviewInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPositionList(temp, data) {
    return new Promise((resolve, reject) => {
      getPositionList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      await dispatch('setToken', token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
